import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["loadedState" ]

  initialize(){
    $(this.loadedStateTarget).removeClass("d-none").addClass("d-flex")  
  }
}
